import { Box, FormHelperText, SxProps } from "@mui/material";

const InputErrorText = ({
  error,
  sx,
  disablePopup = false,
}: {
  error?: string;
  sx?: SxProps;
  disablePopup?: boolean;
}) => (
  <>
    {error && (
      <FormHelperText
        error
        sx={{ position: "relative", display: "flex", ...sx }}
      >
        <Box
          component="span"
          sx={{
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "inline-block",
            width: "100%",
          }}
        >
          {error}
        </Box>
        {error?.length > 45 && !disablePopup && (
          <Box
            sx={{
              display: "none",
              background: "black",
              color: "white",
              position: "absolute",
              bottom: "100%",
              left: "-3px",
              fontSize: "12px",
              borderRadius: "8px",
              padding: "5px",
              "*:hover > &": { display: "block" },
            }}
          >
            {error}
          </Box>
        )}
      </FormHelperText>
    )}
  </>
);

export default InputErrorText;
